import 'lodash/get';
import 'yup';
export { i as default } from './chunks/index--VTS8j_L.mjs';
import 'react/jsx-runtime';
import 'react';
import '@strapi/design-system';
import '@strapi/icons';
import 'react-intl';
import 'styled-components';
import '@reduxjs/toolkit/query';
import '@strapi/admin/strapi-admin';
import '@strapi/content-manager/strapi-admin';
import 'react-router-dom';
import 'qs';
import 'lodash/omit';
//# sourceMappingURL=index.mjs.map
